<template>
    <div id="bottom_page">
        <div class="bottom_page1">共 <span>{{ total }}</span> 条</div>
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="pageNum" :page-size="pageSize"
            layout="prev, pager, next, jumper" :total="total">
        </el-pagination>
    </div>
</template>

<script>
export default {
    props: {
        total: {
            type: Number,
            default: null
        },
        pageSize:{
            type:Number,
            default:10
        }
    },
    data() {
        return {
            pageNum: 1,
            containerWidth: 0
        }
    },
    computed: {
        calculatedWidth() {
            return this.containerWidth - this.reduce;
        }
    },
    mounted() {
        this.containerWidth = this.$el.parentNode.offsetWidth;
    },
    methods: {
        handleCurrentChange(val) {
            this.$emit('currentNUm', val)
        },
        page(num){
            this.pageNum = num
            console.log('this.pageNum=',this.pageNum)
        },
        getPageNum(){
            return this.pageNum
        }
    }
}
</script>

<style>
#bottom_page {
    width: 100%;
    flex-shrink: 0;
    height: 75px;
    background-color: #FFFFFF;
    box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);
    border-radius: 8px 8px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 25px;
}

.bottom_page1 {
    font-weight: bold;
    font-size: 15px;
    color: #000000;
}

.bottom_page1 span {
    color: var(--tech-primary);
}

.el-pager li.active {
    color: var(--tech-primary);
}

.number:hover {
    color: var(--tech-primary) !important;
}
</style>    